export default __webpack_public_path__ + "static/media/cs_icon_08.f2f6504c.png";